/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CoursefinancialCoursefinancialidClassesId204,
  DeleteApiV1CoursefinancialCoursefinancialidClassesId401,
  DeleteApiV1CoursefinancialCoursefinancialidClassesId404,
  DeleteApiV1CoursefinancialCoursefinancialidClassesId500,
  DeleteApiV1CoursefinancialCoursefinancialidClassesIdMutationResponse,
  DeleteApiV1CoursefinancialCoursefinancialidClassesIdPathParams,
} from "../../types/courseFinancialClassesController/DeleteApiV1CoursefinancialCoursefinancialidClassesId.ts";

export const deleteApiV1CoursefinancialCoursefinancialidClassesIdPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidClassesIdPathParams>;

/**
 * @description (No Content) Requisição não encontrou resultados.
 */
export const deleteApiV1CoursefinancialCoursefinancialidClassesId204Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidClassesId204>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CoursefinancialCoursefinancialidClassesId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidClassesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CoursefinancialCoursefinancialidClassesId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidClassesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CoursefinancialCoursefinancialidClassesId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidClassesId500>;

export const deleteApiV1CoursefinancialCoursefinancialidClassesIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1CoursefinancialCoursefinancialidClassesId204Schema,
  ) as unknown as ToZod<DeleteApiV1CoursefinancialCoursefinancialidClassesIdMutationResponse>;
